import { FeatureType } from "@/geoMap/define/FeatureType";
import { AttributeView } from "./AttributeView";
import { RoadStructuresBridgesAttributeConvert } from "./RoadStructuresBridgesAttributeConvert";

/**
 * 画面タイトル
 */
const VALUE_TITLE = "点検DB（横断歩道橋）";

/**
 * 点検データ（横断歩道橋）属性変換クラス
 */
export class RoadStructuresPedestrianDecksAttributeConvert extends RoadStructuresBridgesAttributeConvert {
  /**
   * 地物タイプ
   */
  _featureType = FeatureType.PedestrianDecks;

  /**
   * 画面用フォーマットに変換
   * ※画面項目がシェッドと同一の為、点検データ（道路橋）属性変換クラスを実行し、タイトルのみ差し替え
   */
  getViewFormatData(): AttributeView {
    const formatData = super.getViewFormatData();
    formatData.title = VALUE_TITLE;
    return formatData;
  }
}
